/* Beds & Bedding store-grid adapter.
   Hydrates store cards from the normalized BB.stores contract.
   Brand grids use server-rendered projections when available; only when projections are missing does the
   adapter ask the existing Public Store API for a brand-filtered fallback. */
(function initStoreGridAdapter() {
  'use strict';
  if (window.__bbStoreGridInitialized) return;
  window.__bbStoreGridInitialized = true;

  var BB = window.BB;
  if (!BB || !BB.stores) return;

  function one(root, selector) { return root ? root.querySelector(selector) : null; }
  function setHidden(el, hidden) { if (el) el.hidden = !!hidden; }
  function gridItem(card) { return card && typeof card.closest === 'function' ? card.closest('[data-store-grid-item]') : null; }
  function setCardVisible(card, visible) {
    var item = gridItem(card);
    if (item) item.hidden = !visible;
    else if (card) card.hidden = !visible;
  }
  function clearStatus(el) {
    if (!el) return;
    el.textContent = '';
    el.classList.remove('is-open', 'is-closed');
    el.hidden = true;
  }
  function setLink(link, href) {
    if (!link) return;
    if (href) { link.setAttribute('href', href); link.hidden = false; }
    else { link.removeAttribute('href'); link.hidden = true; }
  }

  function operationalLinks(card) {
    return {
      page: one(card, '[data-store-page-link]'),
      route: one(card, '[data-bb-store-route]'),
      phone: one(card, '[data-bb-store-call]'),
      email: one(card, '[data-store-email]')
    };
  }

  function resetIdentity(card) {
    var generic = card.getAttribute('data-store-generic-name') || '';
    var title = one(card, '[data-store-name]');
    if (title) title.textContent = generic;
    var image = one(card, '[data-store-image] img');
    if (image) image.alt = generic;
    var appointment = one(card, '[data-bb-appointment]');
    if (appointment) appointment.removeAttribute('data-store-name');
  }

  function prepareCard(card) {
    var contentState = card.getAttribute('data-store-content');
    if (contentState === 'projection' || contentState === 'projection-stale') return;
    card.removeAttribute('data-store-source');
    resetIdentity(card);
    var address = one(card, '[data-store-address]');
    var status = one(card, '[data-store-status]');
    var hours = one(card, '[data-store-hours-fallback]');
    var links = operationalLinks(card);
    setHidden(address, true);
    clearStatus(status);
    if (hours) { hours.textContent = BB.t('loading'); hours.hidden = false; }
    setLink(links.page, null);
    setLink(links.route, null);
    setLink(links.phone, null);
    setLink(links.email, null);
  }

  function applyNonPlatform(card, state) {
    card.setAttribute('data-store-source', state);
    card.setAttribute('data-store-content', 'missing');
    resetIdentity(card);
    var address = one(card, '[data-store-address]');
    var status = one(card, '[data-store-status]');
    var hours = one(card, '[data-store-hours-fallback]');
    var links = operationalLinks(card);
    setHidden(address, true);
    clearStatus(status);
    if (hours) {
      hours.textContent = BB.stores.format.resultState({ state: state }).text;
      hours.hidden = false;
    }
    setLink(links.page, null);
    setLink(links.route, null);
    setLink(links.phone, null);
    setLink(links.email, null);
  }

  function applyPlatform(card, store) {
    card.setAttribute('data-store-source', BB.stores.states.PLATFORM);
    card.setAttribute('data-store-content', store.projectionState || 'missing');

    var title = one(card, '[data-store-name]');
    var addressEl = one(card, '[data-store-address]');
    var statusEl = one(card, '[data-store-status]');
    var hoursEl = one(card, '[data-store-hours-fallback]');
    var links = operationalLinks(card);
    var address = BB.stores.format.address(store.address);
    var openState = BB.stores.format.openState(store);

    var generic = card.getAttribute('data-store-generic-name') || '';
    if (title) title.textContent = store.name || generic;
    var image = one(card, '[data-store-image] img');
    if (image) image.alt = store.name || generic;

    if (addressEl) {
      addressEl.textContent = address.singleLine || '';
      addressEl.hidden = !address.singleLine;
    }

    clearStatus(statusEl);
    if (hoursEl) hoursEl.hidden = true;
    if (openState.state === 'open' || openState.state === 'closed') {
      if (statusEl) {
        statusEl.textContent = openState.text;
        statusEl.classList.add('is-' + openState.state);
        statusEl.hidden = false;
      }
    } else if (hoursEl) {
      hoursEl.textContent = openState.text;
      hoursEl.hidden = false;
    }

    setLink(links.page, store.shopifyPageUrl);
    setLink(links.route, BB.stores.format.routeUrl(store));

    var phoneHref = BB.stores.format.telHref(store);
    setLink(links.phone, phoneHref);
    var phoneText = one(links.phone, '[data-store-phone-text]');
    if (phoneText) phoneText.textContent = phoneHref && store.contact && store.contact.phone ? store.contact.phone : '';

    var emailHref = BB.stores.format.emailHref(store);
    setLink(links.email, emailHref);
    var emailText = one(links.email, '[data-store-email-text]');
    if (emailText) emailText.textContent = emailHref && store.contact && store.contact.email ? store.contact.email : '';

    var match = one(card, '[data-store-match]');
    if (match) {
      match.textContent = '';
      match.hidden = true;
      match.className = 'bb-store-card__match bb-small';
      if (BB.showroom) {
        var ev = BB.showroom.normalize(store);
        var matchText = '';
        if (ev.level === 'exact_product' && ev.status === 'in_assortment') matchText = BB.t('matchAssortment');
        else if (ev.level === 'exact_product' && ev.status === 'on_display') matchText = BB.t('matchDisplay');
        else if (ev.level === 'exact_product' && ev.status === 'available_for_demo') matchText = BB.t('matchDemo');
        else if (ev.level === 'brand_only') matchText = ev.brand ? BB.t('matchBrandNamed', { brand: ev.brand.name }) : BB.t('matchBrand');
        if (matchText) { match.textContent = matchText; match.classList.add('is-' + ev.level); match.hidden = false; }
      }
    }

    var appointment = one(card, '[data-bb-appointment]');
    if (appointment) {
      if (store.name) appointment.setAttribute('data-store-name', store.name);
      else appointment.removeAttribute('data-store-name');
    }
  }

  function plotMap(grid, result) {
    var section = grid && grid.closest ? grid.closest('[data-bb-store-grid]') : null;
    var map = section ? one(section, '[data-store-grid-map]') : null;
    var wrap = section ? one(section, '[data-store-grid-map-wrap]') : null;
    var workspace = section ? one(section, '[data-store-grid-workspace]') : null;
    if (!map || !wrap || !workspace || typeof map.setStores !== 'function') return;
    if (!map.hasAttribute('data-store-grid-map-bound')) {
      map.setAttribute('data-store-grid-map-bound', '');
      map.addEventListener('bb-map:error', function () {
        wrap.hidden = true;
        workspace.classList.remove('bb-store-grid__workspace--map');
      });
      map.addEventListener('bb-map:select', function (event) {
        var selectedSlug = event.detail && event.detail.slug;
        Array.prototype.forEach.call(grid.querySelectorAll('.bb-store-card'), function (card) {
          card.classList.toggle('is-selected', !!selectedSlug && card.getAttribute('data-store-slug') === selectedSlug);
        });
      });
    }

    var visible = Object.create(null);
    Array.prototype.forEach.call(grid.querySelectorAll('.bb-store-card'), function (card) {
      var item = gridItem(card);
      var slug = card.getAttribute('data-store-slug');
      if (slug && !card.hidden && (!item || !item.hidden)) visible[slug] = true;
    });

    var points = [];
    if (result && result.state === BB.stores.states.PLATFORM) {
      result.stores.forEach(function (store) {
        if (!store || !store.slug || !visible[store.slug] || !store.coordinates) return;
        var lat = store.coordinates.latitude;
        var lng = store.coordinates.longitude;
        if (typeof lat !== 'number' || typeof lng !== 'number' || !isFinite(lat) || !isFinite(lng)) return;
        points.push({ slug: store.slug, name: store.name || '', lat: lat, lng: lng });
      });
    }

    var hasPoints = points.length > 0 && map.getAttribute('data-map-state') !== 'error';
    map.setStores(points);
    wrap.hidden = !hasPoints;
    workspace.classList.toggle('bb-store-grid__workspace--map', hasPoints);
  }

  function updateProductStatus(grid, state) {
    const section = grid.closest('[data-bb-store-grid]');
    const status = section && one(section, '[data-bb-store-grid-status]');
    if (!status) return;
    status.hidden = !state;
    if (state) status.textContent = status.getAttribute('data-status-' + state) || '';
  }

  function applyGridResult(grid, result) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.bb-store-card'));
    var brandFilter = grid.getAttribute('data-store-brand-filter') || '';
    var productFilter = grid.getAttribute('data-store-product-gid') || '';

    if (!result || result.state !== BB.stores.states.PLATFORM) {
      var fallbackState = result && result.state === BB.stores.states.UNLISTED ? BB.stores.states.UNLISTED : BB.stores.states.UNAVAILABLE;
      if (brandFilter || productFilter) {
        grid.hidden = true;
        cards.forEach(function (card) { setCardVisible(card, false); });
        if (productFilter) updateProductStatus(grid, 'error');
      } else {
        cards.forEach(function (card) {
          setCardVisible(card, true);
          applyNonPlatform(card, fallbackState);
        });
      }
      grid.setAttribute('data-store-authority-state', fallbackState);
      grid.setAttribute('data-store-content', 'missing');
      grid.removeAttribute('aria-busy');
      plotMap(grid, result);
      return;
    }

    var bySlug = Object.create(null);
    var selectedStores = result.stores;
    var productMode = 'none';
    if (productFilter) {
      selectedStores = [];
      if (BB.showroom && typeof BB.showroom.selectStores === 'function') {
        var unique = grid.closest('[data-bb-unique-showroom]') !== null;
        var selection = BB.showroom.selectStores(result.stores, unique);
        if (!unique || selection.exact.length === 1) {
          selectedStores = selection.selected;
          productMode = selection.mode;
        }
      }
    }
    selectedStores.forEach(function (store) { if (store && store.slug) bySlug[store.slug] = store; });

    var visibleCards = 0;
    cards.forEach(function (card) {
      var slug = card.getAttribute('data-store-slug');
      if (slug && bySlug[slug]) {
        setCardVisible(card, true);
        applyPlatform(card, bySlug[slug]);
        visibleCards += 1;
      } else if (brandFilter || productFilter) {
        setCardVisible(card, false);
      } else {
        setCardVisible(card, true);
        applyNonPlatform(card, BB.stores.states.UNLISTED);
      }
    });

    if (brandFilter || productFilter) grid.hidden = visibleCards === 0;
    else grid.hidden = false;
    if (productFilter) {
      var cardsGrid = one(grid, '.bb-stores__grid');
      if (cardsGrid) {
        cardsGrid.setAttribute('data-store-count', String(visibleCards));
        cardsGrid.style.setProperty('--bb-cols-desktop', String(Math.max(1, Math.min(visibleCards, 4))));
        if (visibleCards <= 1) cardsGrid.style.setProperty('--bb-cols-tablet', '1');
        else cardsGrid.style.removeProperty('--bb-cols-tablet');
      }
      updateProductStatus(grid, visibleCards === 0 ? 'no-match' : null);
      var section = grid.closest('[data-bb-store-grid]');
      var heading = section && section.querySelector('.bb-section-header h2');
      if (heading) {
        if (productMode === 'brand') heading.textContent = BB.t(visibleCards === 1 ? 'presenceBrandHeadingOne' : 'presenceBrandHeadingMany');
        else if (productMode === 'none') heading.textContent = BB.t('presenceGenericHeading');
        else heading.textContent = BB.t(visibleCards === 1 ? 'presenceProductHeadingOne' : 'presenceProductHeadingMany');
      }
    }
    grid.setAttribute('data-store-authority-state', BB.stores.states.PLATFORM);
    grid.setAttribute('data-store-content', (result && result.contentState) || 'missing');
    grid.removeAttribute('aria-busy');
    plotMap(grid, result);
  }

  function gridsIn(root) {
    var out = [];
    if (root && typeof root.matches === 'function' && root.matches('[data-bb-store-grid]')) out.push(root);
    if (root && typeof root.querySelectorAll === 'function') {
      Array.prototype.forEach.call(root.querySelectorAll('[data-bb-store-grid]'), function (grid) {
        if (out.indexOf(grid) === -1) out.push(grid);
      });
    }
    return out.filter(function (grid) { return !grid.hasAttribute('data-store-grid-bound'); });
  }

  function fetchContext(grid, hasSSRProjection) {
    var productGid = grid.getAttribute('data-store-product-gid') || '';
    var productBrand = grid.getAttribute('data-store-product-brand') || '';
    if (productGid) return { productGid: productGid, brand: productBrand };
    var brandFilter = grid.getAttribute('data-store-brand-filter') || '';
    if (!hasSSRProjection && brandFilter) return { brand: brandFilter };
    return {};
  }

  function init(root) {
    var grids = gridsIn(root || document);
    if (!grids.length) return Promise.resolve(null);

    var jobs = grids.map(function (grid) {
      grid.setAttribute('data-store-grid-bound', '');
      var contentState = grid.getAttribute('data-store-content');
      var hasSSRProjection = contentState === 'projection' || contentState === 'projection-stale';
      var brandFilter = grid.getAttribute('data-store-brand-filter') || '';

      grid.setAttribute('data-store-authority-state', hasSSRProjection ? BB.stores.states.PLATFORM : 'loading');
      if (hasSSRProjection) grid.removeAttribute('aria-busy');
      else {
        grid.setAttribute('aria-busy', 'true');
        if (brandFilter || grid.hasAttribute('data-store-product-gid')) grid.hidden = true;
      }

      Array.prototype.forEach.call(grid.querySelectorAll('.bb-store-card'), prepareCard);

      var ctx = fetchContext(grid, hasSSRProjection);
      var source = ctx.productGid && BB.showroom && typeof BB.showroom.fetchStores === 'function'
        ? BB.showroom.fetchStores(ctx).then(function (stores) {
          return { state: BB.stores.states.PLATFORM, stores: stores.map(BB.stores.normalize).filter(Boolean), source: 'api', contentState: 'missing' };
        })
        : BB.stores.fetchList(ctx);
      return source.then(function (result) {
        applyGridResult(grid, result);
        return result;
      }).catch(function () {
        var result = { state: BB.stores.states.UNAVAILABLE, stores: [] };
        applyGridResult(grid, result);
        return result;
      });
    });

    return Promise.all(jobs);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
